import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'react-apollo';

import {query} from 'flows/account/profile';

import Spinner from 'components/Spinner';
import Page from 'components/Page';

import Profile from './component';

import './style.css';

export const ProfileContainer = ({data: {loading, userinfo}}) => {
  if (loading) {
    return (
      <Page styleName="loadContainer">
        <Spinner />
      </Page>
    );
  }

  return (
    <Profile userinfo={userinfo}/>
  );
};


ProfileContainer.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    userinfo: PropTypes.object,
  }).isRequired,
};

export default graphql(query)(ProfileContainer);



// WEBPACK FOOTER //
// ./web/flows/account/components/Profile/index.js